var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('moduleHeader',{attrs:{"title":"投资规划"}}),(_vm.alone === '1')?_c('aloneAsGroup'):_vm._e(),(_vm.alone === '2')?_c('asGroup'):_vm._e(),_c('setPlan')],1)}
var staticRenderFns = []

export { render, staticRenderFns }